
import * as actionType from './actionTypes'
import { recommendAnExchangeDataSuccessType } from '../../../../actions/globalActionTypes'


export const fetchCustomPoolFee = payload => ({
  type: actionType.fetchCustomPoolFeeType,
  payload,
});

export const recommendAnExchangeDataSuccess = payload => ({
  type: recommendAnExchangeDataSuccessType,
  payload,
});

export const recommendAnExchangeFromDataSuccess = payload => ({
  type: actionType.recommendAnExchangeFromDataSuccessType,
  payload,
});

export const updateOneTimeFormFields = payload => ({
  type: actionType.updateOneTimeFormFieldsType,
  payload,
});

export const updateRecurringFormFields = payload => ({
  type: actionType.updateRecurringFormFieldsType,
  payload,
});

export const enableOnetimeRecommendFrom = payload => ({
  type: actionType.enableOnetimeRecommendFromType,
  payload,
});

export const enableRecurringRecommendFrom = payload => ({
  type: actionType.enableRecurringRecommendFromType,
  payload,
});

export const updateTabActive = payload => ({
  type: actionType.updateTabActiveType,
  payload,
});

export const initializeFromPools = payload => ({
  type: actionType.initializeFromPoolsType,
  payload,
});

export const initializeToPools = payload => ({
  type: actionType.initializeToPoolsType,
  payload,
});

export const makeFromToPools = payload => ({
  type: actionType.makeFromToPoolsType,
  payload,
});

export const makeToPools = payload => ({
  type: actionType.makeToPoolsType,
  payload,
});

export const updateFromFormField = payload => ({
  type: actionType.updateFromFormFieldType,
  payload,
});

export const updateToFormField = payload => ({
  type: actionType.updateToFormFieldType,
  payload,
});

export const updateActivePageStepName = payload => ({
  type: 'UPDATE_ACTIVE_PAGE_STEP_NAME',
  payload,
});

export const reallocatePools = payload => ({
  type: actionType.reallocatePoolsType,
  payload,
});

export const resetFromPools = () => ({
  type: actionType.resetFromPoolsType,
});

export const clearFromPool = payload => ({
  type: actionType.clearFromPoolType,
  payload,
});

export const switchExchangeUnit = payload => ({
  type: 'SWITCH_EXCHANGE_UNIT',
  payload,
});

export const updateFromTotal = payload => ({
  type: 'UPDATE_FROM_TOTAL',
  payload,
});

export const updateRecordedVal = payload => ({
  type: 'UPDATE_RECORDED_VAL',
  payload,
});

export const updateDollarsTotal = () => ({
  type: actionType.updateDollarsTotalType,
});

export const updatePercentageTotal = () => ({
  type: actionType.updatePercentageTotalType,
});

export const validateFromPoolsState = payload => ({
  type: actionType.validateFromPoolsStateType,
  payload,
});

export const validateToPools = payload => ({
  type: actionType.validateToPoolsType,
  payload,
});

export const resetToPools = () => ({
  type: actionType.resetToPoolsType,
});

export const validateSubmit = payload => ({
  type: actionType.validateSubmitType,
  payload,
});

export const submitFormSuccess = payload => ({
  type: 'SUBMIT_FORM_SUCCESS',
  payload,
});

export const updateActiveConfirmation = payload => ({
  type: actionType.updateActiveConfirmationType,
  payload,
});

export const switchInvestmentOption = payload => ({
  type: actionType.switchInvestmentOptionType,
  payload,
});

export const toggleInvestmentOptionModal = payload => ({
  type: actionType.toggleInvestmentOptionModalType,
  payload,
});

// export const modalOk = payload => ({
//   type: 'MODAL_OK',
//   payload,
// });

export const showUpdateButton = payload => ({
  type: actionType.showUpdateButtonType,
  payload,
});

export const setOldState = payload => ({
  type: actionType.setOldStateType,
  payload,
});

export const beforePoolsState = payload => ({
  type: actionType.beforePoolsStateType,
  payload,
});

export const beforeToPoolState = payload => ({
  type: actionType.beforeToPoolStateType,
  payload,
});

export const fetchPoolData = payload => ({
  type: actionType.fetchPoolDataType,
  payload,
});

export const fetchUnderlyingFunds = payload => ({
  type: actionType.fetchUnderlyingFundsType,
  payload,
});

export const switchTabExchange = payload => ({
  type: actionType.switchTabExchangeType,
  payload,
});

export const setPathFromTIFF = payload => ({
  type: actionType.setPathFromTIFFType,
  payload,
});


export const setEndDateWorker = payload => ({
  type: actionType.setEndDateWorkerType,
  payload,
});

export const setNumberOfExchange = payload => ({
  type: actionType.setNumberOfExchangeType,
  payload,
});

export const setDate = payload => ({
  type: actionType.setDateType,
  payload,
});

export const setPoolModalFalse = payload => ({
  type: actionType.setPoolModalFalseType,
  payload,
});

export const fetchAllPoolData = payload => ({
  type: actionType.fetchAllPoolDataType,
  payload,
});

export const setPendingPopUp = payload => ({
  type: actionType.setPendingPopUpType,
  payload,
});

export const exitRecommendAnExchange = payload => ({
  type: actionType.exitRecommendAnExchangeType,
  payload,
});

export const setDataClearMessage = payload => ({
  type: actionType.setDataClearMessageType,
  payload,
});

export const setExchangeFlagAndData = payload => ({
  type: actionType.setExchangeFlagAndDataType,
  payload,
});

export const setFromNewPools = payload => ({
  type: actionType.setFromNewPoolsType,
  payload
});

export const setToNewPools = payload => ({
  type: actionType.setToNewPoolsType,
  payload
});

export const setexchangePath = payload =>({
  type: actionType.setexchangePathType,
  payload
});

export const setExchangeType = payload => ({
  type: actionType.setExchangeTypeType,
  payload
});

export const enableSteppers = payload => ({
  type: actionType.enableSteppersType,
  payload
})

export const resetEditFlag = payload => ({
  type: actionType.resetEditFlagType,
  payload
});

export const fetchTradeDate = payload => ({
  type: actionType.fetchTradeDateType,
  payload
});

export const setStartDate = payload => ({
  type: actionType.setStartDateType,
  payload
});

export const setEndDate = payload => ({
  type: actionType.setEndDateType,
  payload
});

export const setFrequency = payload => ({
  type: actionType.setFrequencyType,
  payload
});

export const setNumOfExchanges = payload => ({
  type: actionType.setNumOfExchangesType,
  payload
});

export const submitExchangeUpdate = payload => ({
  type: actionType.submitExchangeUpdateType,
  payload
});

export const submitExchangeUpdateTo = payload => ({
  type: actionType.submitExchangeUpdateToType,
  payload
});

export const activeExchangeScheduleCount = payload => ({
  type: actionType.activeExchangeScheduleCountType,
  payload
});

export const resetRecurring = () => ({
  type: actionType.resetRecurringType
});

export const rsetOneTime = () => ({
  type: actionType.resetOneTimeType
});

export const onExchangeFrom = payload => ({
  type: actionType.onExchangeFromType,
  payload
});

export const onExchangeTo = payload => ({
  type: actionType.onExchangeToType,
  payload
});


export const setRecurringData = payload => ({
  type: actionType.setRecurringDataType,
  payload
});

export const editSteps = payload => ({
  type: actionType.editStepsType,
  payload
})


